import React from 'react';
import {injectIntl} from 'react-intl';

import './HowItWorksPage.sass';

import {connect} from 'react-redux';

import {setBackground} from '../../ducks/ui';

import ChannelLink from '../channelUtils/ChannelLink';

import Meta from '../../components/meta/Meta';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import FeatureText from '../../components/featureText/FeatureText';
import Hexagon from '../../components/hexagon/Hexagon';
import JSONLDBoosthive from '../../components/JSON-LD/JSONLDBoosthive';

import hiw1 from './assets/hiw1.svg';
import hiw2 from './assets/hiw2.svg';
import hiw3 from './assets/hiw3.svg';
import hiw4 from './assets/hiw4.svg';
import hiw5 from './assets/hiw5.svg';

@injectIntl
@connect()
export default class HowItWorksPage extends React.PureComponent {
  componentDidMount() {
    const {dispatch} = this.props;

    dispatch(setBackground());
  }

  render() {
    const {intl} = this.props;

    return (
      <React.Fragment>
        <Meta
          fallbackTitle={intl.formatMessage({id: 'page.how-it-works.title'})}
          description={intl.formatMessage({id: 'page.how-it-works.description'})}
          alternateSlug="how-it-works"
        />

        <JSONLDBoosthive />

        <div className="page-hiw">
          <Breadcrumbs links={[{name: intl.formatMessage({id: 'page.how-it-works.title'})}]}/>

          <FeatureText
            center
            headerComponent="h1"
            header={intl.formatMessage({id: 'page.how-it-works.title'})}
            text={intl.formatMessage({id: 'page.how-it-works.description'})}
          />

          <div className="page-hiw__steps">
            <div className="page-hiw__step">
              <Hexagon bordered>
                <img src={hiw1} alt="cart"/>
              </Hexagon>

              <div className="page-hiw__step-header">
                {intl.formatMessage({id: 'page.how-it-works.steps.one.title'})}
              </div>
              <div className="page-hiw__step-desc">
                {intl.formatMessage({id: 'page.how-it-works.steps.one.description'})}
              </div>
            </div>

            <div className="page-hiw__step">
              <Hexagon bordered>
                <img src={hiw2} alt="list"/>
              </Hexagon>

              <div className="page-hiw__step-header">
                {intl.formatMessage({id: 'page.how-it-works.steps.two.title'})}
              </div>
              <div className="page-hiw__step-desc">
                {intl.formatMessage({id: 'page.how-it-works.steps.two.description'})}
              </div>
            </div>

            <div className="page-hiw__step">
              <Hexagon bordered>
                <img src={hiw3} alt="client list"/>
              </Hexagon>

              <div className="page-hiw__step-header">
                {intl.formatMessage({id: 'page.how-it-works.steps.three.title'})}
              </div>
              <div className="page-hiw__step-desc">
                {intl.formatMessage({id: 'page.how-it-works.steps.three.description'})}
              </div>
            </div>

            <div className="page-hiw__step">
              <Hexagon bordered>
                <img src={hiw4} alt="check"/>
              </Hexagon>

              <div className="page-hiw__step-header">
                {intl.formatMessage({id: 'page.how-it-works.steps.four.title'})}
              </div>
              <div className="page-hiw__step-desc">
                {intl.formatMessage({id: 'page.how-it-works.steps.four.description'})}
              </div>
            </div>

            <div className="page-hiw__step">
              <Hexagon bordered>
                <img src={hiw5} alt="medal"/>
              </Hexagon>

              <div className="page-hiw__step-header">
                {intl.formatMessage({id: 'page.how-it-works.steps.five.title'})}
              </div>
              <div className="page-hiw__step-desc">
                {intl.formatMessage({id: 'page.how-it-works.steps.five.prefix'})}{' '}<ChannelLink to="/reviews">{intl.formatMessage({id: 'page.how-it-works.steps.five.feedback'})}</ChannelLink>{' '}{intl.formatMessage({id: 'page.how-it-works.steps.five.suffix'})}</div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/howItWorksPage/HowItWorksPage.js